/** Company narrative, team, and project-client data, from the Kanata Indonesia
 *  Company Profile 2026. Copy is Bahasa Indonesia, kamu. */

export const credo = {
  heading: "Yang kami pegang",
  intro:
    "Kerja yang sehat dan produktif berangkat dari hal yang sederhana: mejanya nyaman dipakai seharian.",
  paragraphs: [
    "Pelanggan, partner dan tim kami satu keluarga. Karena itu kualitas dan harga yang masuk akal bukan dua hal yang harus kamu pilih salah satu.",
    "Kami bikin sendiri di Indonesia, jadi kami tahu persis apa yang ada di dalam meja yang kamu beli — dan bisa memperbaikinya kalau ada apa-apa.",
    "Setiap orang di Kanata Family kami perlakukan setara: partner, tim, dan kamu yang beli satu meja untuk di rumah.",
  ],
} as const;

export interface TeamMember {
  name: string;
  role: string;
}

export const team: TeamMember[] = [
  { name: "Divine Samuel", role: "Co-Founder" },
  { name: "Yosua Nathanael", role: "Co-Founder" },
  { name: "Remmy J. Arief", role: "Head of Operations" },
];

/** Values, for the About page. */
export const values = [
  {
    title: "Satu keluarga",
    body: "Pelanggan, partner dan tim ada di sisi yang sama. Kamu beli satu meja atau seratus, layanannya sama.",
  },
  {
    title: "Kualitas tidak ditawar",
    body: "Material dan rakitan yang benar, dengan harga yang tetap masuk akal. Bukan salah satunya.",
  },
  {
    title: "Dibuat di Indonesia",
    body: "Diproduksi sendiri, jadi sparepart ada dan perbaikan tidak perlu menunggu kiriman dari luar.",
  },
  {
    title: "Selesai setelah dipakai",
    body: "Pemasangan, pengecekan, dan bantuan setelahnya. Transaksi selesai bukan waktu meja sampai, tapi waktu mejanya jalan.",
  },
];

/** Industries Kanata has done office projects for. */
export const industries = [
  "Pendidikan",
  "IT",
  "Medis",
  "Keuangan",
  "Makanan & Minuman",
  "Industri",
];

export interface Client {
  slug: string;
  name: string;
  industry: string;
  location: string;
  summary: string;
  /** Ordered image keys for the client gallery. */
  imageKeys: string[];
}

/** Office projects Kanata has delivered. Proof, not a sales funnel — the CTA
 *  is a WhatsApp conversation, not a quote form. */
export const clients: Client[] = [
  {
    slug: "greenshield",
    name: "Greenshield",
    industry: "Financial · Insurance",
    location: "Jakarta",
    summary:
      "Satu lantai kantor dikerjakan penuh: konsultasi, standing desk yang disesuaikan, sampai pemasangan di tempat.",
    imageKeys: ["greenshield-1", "greenshield-2", "greenshield-3"],
  },
  {
    slug: "kreditplus",
    name: "Kreditplus",
    industry: "Financial services",
    location: "Prosperity Tower, Jakarta",
    summary:
      "Kantor pusat baru dari nol: konsultasi, konstruksi, penyesuaian produk, penataan workspace, dan setup lengkap.",
    imageKeys: ["kreditplus-1", "kreditplus-2", "kreditplus-3"],
  },
  {
    slug: "hensel",
    name: "Hensel Electric",
    industry: "Industrials · Electrical",
    location: "Industri Delta Silicon, Bekasi",
    summary:
      "Peremajaan kantor untuk tim manajemen — standing desk yang disesuaikan dengan ruang kerja Hensel.",
    imageKeys: ["hensel-1", "hensel-2", "hensel-3"],
  },
];
